export const OFFSET = "10px 0";

export const POPOVER_ANCHOR_ORIGIN = {
  vertical: "bottom" as const,
  horizontal: "left" as const,
};

export const POPOVER_TRANSFORM_ORIGIN = {
  vertical: "top" as const,
  horizontal: "left" as const,
};

export const POPOVER_DEFAULT_SLOT_PROPS = {
  root: {
    slotProps: {
      backdrop: {
        sx: {
          backgroundColor: "transparent",
        },
      },
      root: {
        "data-test-id": "select-popover-backdrop",
      },
    },
  },
};
